<template>
  <div>
    <transition name="fadeMenu">

      <div class="drop-down" v-if="selectedDevice">
        <h2>{{ selectedDevice.name }}</h2>
        <p v-bind:class="{ full: usedCameras > 10 }">
          {{ usedCameras }} / 10 cameras
        </p>
        <router-link tag="button" v-if="userType != 'user'"
          :to="{ name: 'AddCamera', params: { id: selectedDevice.id } }"
          :disabled="!selectedDevice || (usedCameras >= 10 && !isSoldelAdmin)">
          Add Camera
        </router-link>
        <!--
        <router-link tag="button" :disabled="!selectedDevice" to="Cameras">
          Settings
        </router-link>
        -->
      </div>
    </transition>

    <div class="blackout" @click="select(null)" v-if="selectedDevice"></div>
    <div class="wrapper" v-if="deviceList">
      <header>
        <h1>Devices</h1>
        <router-link to="AddDevice" class="bgSvg">
          <svg width='30' height='30' viewBox='0 0 30 30' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><path d='M15 0C15.4973 0 15.9742 0.197544 16.3258 0.549175C16.6775 0.900806 16.875 1.37772 16.875 1.875V13.125H28.125C28.6223 13.125 29.0992 13.3225 29.4508 13.6742C29.8025 14.0258 30 14.5027 30 15C30 15.4973 29.8025 15.9742 29.4508 16.3258C29.0992 16.6775 28.6223 16.875 28.125 16.875H16.875V28.125C16.875 28.6223 16.6775 29.0992 16.3258 29.4508C15.9742 29.8025 15.4973 30 15 30C14.5027 30 14.0258 29.8025 13.6742 29.4508C13.3225 29.0992 13.125 28.6223 13.125 28.125V16.875H1.875C1.37772 16.875 0.900806 16.6775 0.549175 16.3258C0.197544 15.9742 0 15.4973 0 15C0 14.5027 0.197544 14.0258 0.549175 13.6742C0.900806 13.3225 1.37772 13.125 1.875 13.125H13.125V1.875C13.125 1.37772 13.3225 0.900806 13.6742 0.549175C14.0258 0.197544 14.5027 0 15 0Z'/></svg>
        </router-link>
      </header>
      <ul>
        <button v-for="device in deviceList" :key="device.id" @click="select(device)">
          <Marquee><p>{{ device.name }}</p></Marquee>
        </button>
      </ul>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import Marquee from '../components/Marquee.vue';

export default {
  components: {
    Marquee,
  },
  data() {
    return {
      title: null,
      selectedDevice: null,
    };
  },
  mounted() {
    Auth.currentUserInfo().then((user) => {
      this.email = user.attributes.email;
    });
  },
  methods: {
    select(device) {
      this.selectedDevice = device;
    },
  },
  computed: {
    deviceList() {
      return this.$store.state.devices.deviceList;
    },
    userType() {
      return this.$store.state.user?.userType?.toLowerCase() ?? 'user';
    },
    isSoldelAdmin() {
      const emailPasses = this.email.endsWith('@soldelgroup.com');
      const adminPasses = this.userType.includes('admin');
      const isSoldelAdmin = emailPasses && adminPasses;
      return isSoldelAdmin;
    },
    usedCameras() {
      const deviceInfo = this.deviceList.find((v) => v.id === this.selectedDevice.id);
      return deviceInfo.cameras.length;
    },
  },

};
</script>

<style scoped>
.drop-down {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  padding: 48px 0;
  background: var(--surface);
  width: 100vw;
  z-index: 4;
  box-shadow: var(--shadow);
  border-radius: 0px 0px 30px 30px;
}

.drop-down h2 {
  letter-spacing: 0.015em;
  font-weight: 500;
  font-size: 24px;
}

.drop-down p {
  margin-top: 20px;
  height: 20px;
}

.drop-down button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 155px;
  height: 63px;
  background-color: var(--surface-dark);
  border-radius: var(--border-radius);
  letter-spacing: 0.015em;
  font-weight: 500;
  font-size: 20px;
  margin-top: 28px;
}

.blackout {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100vw;
  height: 100%;
  background: rgba(27, 27, 27, 0.2);
}

ul {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 48px;
}

ul button {
  width: clamp(227px, 80vw, 400px);
  height: 63px;
  border-radius: var(--border-radius);
  padding: 0 10px;
  background-color: var(--surface);

  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.015em;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;
}

header {
  margin-top: 48px;
  display: flex;
  align-items: center;
}

header a {
  margin-left: 22px;
  width: 46px;
  height: 46px;
  padding: 8px;
  box-sizing: border-box;
  color: var(--accent);
  background-color: var(--surface);
  border-radius: var(--border-radius);
}

h1 {
  margin-left: 68px;
  font-weight: 500;
  font-size: 24px;
  letter-spacing: 0.015em;
}

p.full {
  color: var(--error)
}

button[disabled] {
  cursor: default;
  background-color: var(--surface);
}
</style>
